var React = require('react');

function IconFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.503 28l-5.483-.045V15.54H0v-5.368h4.027V7.59C4.027 2.546 6.348 0 10.664 0c.894-.006 1.788.036 2.68.126.255.027.408.048.717.092l.363.054v4.736H11.33c-1.197 0-1.82 1.148-1.82 3.12v2.044h4.94l-.785 5.368H9.503V28z","fill":"#2777b8","fillRule":"evenodd"}));
}

IconFacebookInline.defaultProps = {"viewBox":"0 0 15 28"};

module.exports = IconFacebookInline;

IconFacebookInline.default = IconFacebookInline;
